exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".waybill-popover{padding:30px 40px!important;position:fixed!important;top:10%!important;left:50%!important;-webkit-transform:translateX(-50%)!important;transform:translateX(-50%)!important;line-height:1!important;white-space:nowrap!important;background:#ff0!important}.waybill-popover,.waybill-popover>div{overflow:hidden!important;box-sizing:border-box!important}.waybill-popover>div{max-width:100%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ecdacbbe","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/NewSysPage/index.vue
// module id = 284
// module chunks = 0